import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import NovaVistoria from './NovaVistoria';
import Loading from '../../../components/Loading/Loading';
import TextField from '../../../components/TextField/TextField';
import FiltroPrefeitura from '../FiltroPrefeitura';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Api
import solicitacaoVistoria_api from '../../../api/solicitacaoVistoria_api';
import setor_api from '../../../api/setor_api';


export default function Vistorias() {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Controle dos dados que vem na rota
    const location = useLocation();

    //Opções do campo de status
    const [optionsStatus, setOptionsStatus] = useState([
        { label: "Pendente", value: "Pendente" },
        { label: "Agendada", value: "Agendada" },
        { label: "Em Execução", value: "Em Execução" },
        { label: "Finalizada", value: "Finalizada" },
        { label: "Arquivada", value: "Arquivada" },
    ]);

    const [consultaVistoria, setConsultaVistoria] = useState({
        status: location.state ? location.state.filtros.status : ["Pendente", "Agendada"],
        cpfcnpj: "",
        dataInicial: null,
        dataFinal: null,
        tbSetores_Id: null
    });


    //Filtros que vem da location
    const { filtros, titleTable, filtrosRetorno } = location.state ? location.state : {};

    //Estado de controle das opções de setores
    const [regionais, setRegionais] = useState([]);

    //Estado que controla a visualização dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Troca de estado de visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Variavel de navegação
    const navigate = useNavigate();

    //Estado de controle de exibição da tela de nova vistoria
    const [novo, setNovo] = useState(false);

    //Estado de controle da ficha da vistoria
    const [ficha, setFicha] = useState(null);

    //Estado de controle dos itens da tabela
    const [vistorias, setVistorias] = useState([]);

    //Cabeçalhos da tabela de vistorias
    const headersVistorias = [
        { value: "Identificação do gerador", objectValue: "identificacaoLocalidade" },
        { value: "Endereço", objectValue: "endereco" },
        { value: "Data da Solicitação", objectValue: "dataSolicitacao" },
        { value: "Data Último Agendamento", objectValue: "ultimoAgendamento" },
        { value: "Status", objectValue: "status" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj" },
        { value: "Resultado Final", objectValue: "resultadoFinal" },
        { value: "Total Execuções", objectValue: "totalExecucoes" },
        { value: "Regional", objectValue: "regional" },
    ];

    //Função que carrega a lista de solicitações
    const carregaSolicitacoes = () => {
        if (consultaVistoria.status.some(x => x == "Finalizada") && (consultaVistoria.dataFinal == null || consultaVistoria.dataInicial == null)) {
            showMessage("Aviso", "Por favor, preencha os campos de datas.", "warning", null);
            return;
        }

        const _filtrosRota = {
            ...filtros ? filtros : {},
            status: consultaVistoria.status,
            ...consultaVistoria
        }

        setLoading(true);
        solicitacaoVistoria_api.GetList(_filtrosRota).then(response => {
            response.data = response.data.map(value => {
                value.dataSolicitacao = moment(value.dataSolicitacao).format("DD/MM/YYYY");
                return value;
            })
            setVistorias(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const onChangeCampoStatus = (e, select) => {
        const { name } = select;

        setConsultaVistoria({
            ...consultaVistoria,
            [name]: e && e.length > 0 ? e.map(value => value.value) : []
        });
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setConsultaVistoria({
            ...consultaVistoria,
            [name]: value
        })
    }

    //onChange para o campo de select de tipo de valor
    const onChangeRegional = (e, select) => {
        setConsultaVistoria({
            ...consultaVistoria,
            [select.name]: e != null ? e.value : null
        })
    }

    const loadRegionais = (prefeitura_id) => {
        setor_api.GetListFiltro(prefeitura_id).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao }
            })
            setRegionais(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }

    //Função que faz o controle do id da prefeitura e carrega as regionais
    const handlePrefeitura = (value) => {
        loadRegionais(value);
    }

    const handleArquivar = (rowData) => {
        setLoading(true);
        solicitacaoVistoria_api.UpdateSolicitacaoVistoriaArquivar({
            status: "Arquivada",
            tbSolicitacaoVistoria_Id: rowData.id
        }).then(response => {
            showMessage("Sucesso", "Vistoria arquivada com sucesso.", "success", () => { carregaSolicitacoes() })
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const handleVisualizar = (rowData) => {
        setFicha(rowData.id);
    }

    //Ações da tabela de listagem
    const [actions, setActions] = useState([actionsTable.visualizar(handleVisualizar)]);

    const handleVisibleArquivar = (row) => {
        if(row.status != "Arquivada")
            return actionsTable.arquivar(handleArquivar)
        else 
            return null;
    }
    

    const loadPermissaoFuncionalidade = () => {
        setLoading(true);
        solicitacaoVistoria_api.GetFuncionalidadeFiscal().then(response => {
            let _actions = [...actions];
            if (response.data && response.data?.filter(x => x.funcao == "Vistoria.Arquivar" && x.permissao == "Editar")?.length > 0)
                _actions.push(handleVisibleArquivar);
            //modificando acões
            setActions(_actions);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));

    }

    useEffect(() => {
        carregaSolicitacoes();
        loadPermissaoFuncionalidade();
    }, []);

    if (novo)
        return <NovaVistoria
            btnVoltar={() => {
                carregaSolicitacoes();
                setNovo(false);
            }}
        />

    if (ficha)
        return <NovaVistoria
            btnVoltar={() => {
                carregaSolicitacoes();
                setFicha(null);
            }}
            disabled={true}
            vistoriaFicha={ficha}
        />

    return (
        <MainCard
            btnVoltarInTop={
                location.state && location.state.btnVoltar
                    ?
                    () => navigate(location.state.btnVoltar, { state: { paramsFiltros: filtrosRetorno ? filtrosRetorno : null } })
                    :
                    null
            }
            noCard
            btnCadastro={!filtros ? "Adicionar" : null}
            btnFiltros={toggleFiltros}
            onClickBtnCadastro={!filtros ? () => setNovo(true) : null}
        >
            {loading && <Loading />}
            <FiltroPrefeitura
                handleValue={handlePrefeitura}
            />
            <div className={`filtros ${openFiltros ? "" : "close"}`} id={"filtros"}>
                <Row>
                    <Col md={12} lg={5}>
                        <TextField
                            name={"status"}
                            label={"Selecione os status"}
                            type={"select"}
                            multiple
                            value={optionsStatus.filter(r => consultaVistoria.status.some(x => x == r.value))}
                            options={optionsStatus.filter(r => !consultaVistoria.status.some(x => x == r.value))}
                            onChange={onChangeCampoStatus}
                        />
                    </Col>

                    <Col md="12" lg={3}>
                        <TextField
                            label={"CNPJ"}
                            name={"cpfcnpj"}
                            type={"text"}
                            onChange={onChange}
                            value={consultaVistoria.cpfcnpj}
                            mask={mascaras.cnpjMask}
                            maxLength={18}
                        />
                    </Col>

                    <Col md="12" lg={4}>
                        <TextField
                            maxLength={"30"}
                            label={"Regionais"}
                            type="select"
                            searchable
                            options={regionais}
                            name="tbSetores_Id"
                            value={regionais.filter(x => x.value == consultaVistoria.tbSetores_Id)[0]}
                            onChange={onChangeRegional}
                        />
                    </Col>

                    <Col md="12" lg={6}>
                        <TextField
                            label={"Data inicial"}
                            name={"dataInicial"}
                            type={"date"}
                            onChange={onChange}
                            value={consultaVistoria.dataInicial}
                            maxLength={18}
                        />
                    </Col>

                    <Col md="12" lg={6}>
                        <TextField
                            label={"Data Fim"}
                            name={"dataFinal"}
                            type={"date"}
                            onChange={onChange}
                            value={consultaVistoria.dataFinal}
                            maxLength={18}
                        />
                    </Col>
                </Row>
                <div className='d-flex justify-content-center align-items-center mb-3'>
                    <div>
                        <Button
                            className='fw-bold text-center ms-2'
                            color='primary'
                            onClick={() => carregaSolicitacoes()}>
                            <FontAwesomeIcon className='me-2' icon={faFilter} size={"1x"} /> {`filtros`}
                        </Button>
                    </div>
                </div>
            </div>
            <TabelaListagem
                title={titleTable ? titleTable : 'Lista de vistorias em aberto'}
                headers={headersVistorias}
                items={vistorias}
                actions={actions}
            />
        </MainCard>
    );
}